import { api } from 'utility';
import {
  getMembersActionsUrl,
  getCRUImprestUrl,
  getCitiesUrl,
  getStatesUrl,
  getFinancialAccumulativeReportFunderAndImprestUrl,
  getAccumulativeReportFunderAndImprestUrl,
  getFinancialReportImprestUrl,
  getCreateFunderUrl,
  getCRAclGroupUrl,
  getDetailOrEditAclGroupUrl,
  getTreeEdit,
  getDetailActionsUrl,
  getCheckIsAdminUrl,
  getMemberActionsUrl,
  editGroups,
  groupsAction,
  getTreeAcl
} from 'URLs';
class Services {
  getImprest(params) {
    return api.get(getCRUImprestUrl(), { params }).then((res) => res.data);
  }
  getStates() {
    return api.get(getStatesUrl()).then((res) => res.data);
  }
  getCities(params) {
    return api.get(getCitiesUrl(), { params }).then((res) => res.data);
  }
  addImprest(data) {
    return api.post(getCRUImprestUrl(), data);
  }
  updateImprest(data) {
    return api.put(getCRUImprestUrl(), data);
  }

  funderImprest(data, params) {
    return api
      .post(getFinancialAccumulativeReportFunderAndImprestUrl(), data, { params })
      .then((res) => res.data);
  }
  /**
   * لیست کل تنخواه
   */
  getAllFunderImprest(data, params) {
    return api
      .post(getAccumulativeReportFunderAndImprestUrl(), data, { params })
      .then((res) => res.data);
  }
  getReportSummary(data, params) {
    return api.post(getFinancialReportImprestUrl(), data, { params }).then((res) => res.data);
  }
  getFunder(params) {
    return api.get(getCreateFunderUrl(), { params }).then((res) => res.data);
  }
  getMenus() {
    return api.get(getTreeAcl()).then((res) => res.data);
  }
  getAclList(params) {
    return api.get(getCRAclGroupUrl(), { params }).then((res) => res.data);
  }
  AddAclGroup(data) {
    return api.post(getCRAclGroupUrl(), data).then((res) => res.data);
  }
  AddAclActionGroup(data) {
    return api.post(groupsAction(), data).then((res) => res.data);
  }
  getDetaisAclGroup(path, params) {
    const url = getMemberActionsUrl(path)
    return api.get(url, { params }).then((res) => res.data);
  }
  editAclGroup(path, data) {
    return api.put(editGroups(path), data).then((res) => res.data);
  }

  getDetaisAclGroup(path, params) {
    return api.get(getDetailOrEditAclGroupUrl(path), { params }).then((res) => res.data);
  }
  addAclMemberToGroup(data, path) {
    return api.put(getMemberActionsUrl(path), data).then((res) => res.data);
  }

  deleteAclGroup(path) {
    return api
      .delete(editGroups(path))
      .then((res) => res.data);
  }
  deleteAclUser(path, memeberId, params) {
    return api
      .delete(getMembersActionsUrl(path ,memeberId ), { params })
      .then((res) => res.data);
  }
  getDetailsAclGroup(path, params) {
    return api.get(getDetailActionsUrl(path), { params }).then((res) => res.data);
  }
  getDetailsTree(path) {
    return api.get(getTreeEdit(path)).then((res) => res.data);
  }
  getMemberListAcl(path, params) {
    const url = getMemberActionsUrl(path)
    return api.get(url, { params }).then((res) => res.data);
  }

  /**
   * برای چک کردن ادمین هست یا خیر
   */
  checkAdmin() {
    return api.get(getCheckIsAdminUrl(), {}).then((res) => res.data);
  }
}


export default new Services();
